import React from 'react'
import styled from 'styled-components'
import {BUTTON_SIZE_MAP} from 'consts/components'
import {getBoxShadow} from 'utils/commons'
import convertUnit from 'lib/unit'
import {ButtonIconProps} from './ButtonIconProps'
import {Button} from '../Button'
import {Paragraph} from '../../texts'
import {Icon} from '../../icons'

interface StyledButtonProps {
  hasShadow: boolean
}

const StyledButton = styled(Button)<StyledButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  box-shadow: ${({theme, hasShadow}) =>
    hasShadow
      ? getBoxShadow(theme, {
          horizontalOffset: 1,
          verticalOffset: 2,
          blurRadius: 8,
          opacity: 0.15,
        })
      : undefined};
`

const StyledLabel = styled(Paragraph)`
  margin-left: ${convertUnit(12)};
`

export default function ButtonIcon({
  type = 'normal',
  iconType,
  iconColor = 'gray_1',
  iconStyle,
  hasIconShadow,
  hasShadow = true,
  label,
  ...props
}: ButtonIconProps) {
  return (
    <StyledButton
      {...props}
      type={type}
      width={BUTTON_SIZE_MAP[type]}
      hasShadow={hasShadow}>
      <Icon
        type={iconType}
        size={(BUTTON_SIZE_MAP[type] * 5) / 11}
        color={iconColor}
        style={iconStyle}
        hasShadow={hasIconShadow}
      />
      {label && (
        <StyledLabel fontSize="s" fontWeight="bold" color="white_1">
          {label}
        </StyledLabel>
      )}
    </StyledButton>
  )
}
